import React from 'react';
import { Link } from 'react-router-dom';

function Navigation() {
  return (
    <div id="navigation">
      <ul id="nagv" className="topmenu" style={{ float: 'right' }}>
        <li className="topfirst">
          <Link to="/" style={{ height: '18px', lineHeight: '18px' }}>Home</Link>
        </li>
        <li className="topmenu">
          <Link to="/about" style={{ height: '18px', lineHeight: '18px' }}>
            <span>About-Us</span>
          </Link>
          <ul>
            <li><Link to="/principalsdesk">Principals Desk</Link></li>
            <li><Link to="/governing-council">Sri Krishna Shikshana Prathisthana Trust &amp; Governing Council</Link></li>
          </ul>
        </li>
        <li className="topmenu">
          <Link to="/departments" style={{ height: '18px', lineHeight: '18px' }}>
            <span>Departments</span>
          </Link>
          <ul>
            <li><Link to="/computer-science"><span>Computer Science &amp; Engineering</span></Link></li>
            <li><Link to="/electronics-engineering"><span>Electronics &amp; Communication Engineering</span></Link></li>
            <li><Link to="/mechanical-engineering"><span>Mechanical Engineering</span></Link></li>
            <li><Link to="/apparel-design"><span>Apparel Design &amp; Fabrication Technology</span></Link></li>
          </ul>
        </li>
        <li className="topmenu">
          <Link to="/facilities" style={{ height: '18px', lineHeight: '18px' }}>Facilities</Link>
        </li>
        <li className="topmenu">
          <Link to="/admission" style={{ height: '18px', lineHeight: '18px' }}>
            <span>Admission</span>
          </Link>
        </li>
        <li className="topmenu">
          <Link to="/gallery" style={{ height: '18px', lineHeight: '18px' }}>Photo Gallery</Link>
        </li>
        <li className="toplast">
          <Link to="/contact" style={{ height: '18px', lineHeight: '18px' }}>Contact-Us</Link>
        </li>
      </ul>
    </div>
  );
}

export default Navigation;
